import '../styles/AboutSkills.css';
import python from '../assets/python.svg';
import cplusplus from '../assets/cplusplus.svg';
import java_vertical from '../assets/java-vertical.svg';
import javascript from '../assets/javascript.svg';
import typescript from '../assets/typescript.svg';
import nextdotjs from '../assets/nextdotjs.svg';
import react from '../assets/react.svg';
import html5 from '../assets/html5.svg';
import css3 from '../assets/css.svg';
import nodedotjs from '../assets/nodedotjs.svg';
import express from '../assets/express.svg';
import flask from '../assets/flask.svg';
import mysql from '../assets/mysql.svg';
import postgresql from '../assets/postgresql.svg';
import mssql from '../assets/mssql.svg';
import docker from '../assets/docker.svg';
import git from '../assets/git.svg';
import github from '../assets/github.svg';

export default function AboutSkills() {
    return (
        <div>
            <div className="list list--6">
                <img className="list__item" src={python} alt="python_logo"/>
                <img className="list__item" src={java_vertical} alt="java_logo"/>
                <img className="list__item" src={cplusplus} alt="c++_logo"/>
                <img className="list__item" src={javascript} alt="javascript_logo"/>
                <img className="list__item" src={typescript} alt="typescript_logo"/>
                <img className="list__item" src={nextdotjs} alt="nextjs_logo"/>
                <img className="list__item" src={react} alt="react_logo"/>
                <img className="list__item" src={html5} alt="html_logo"/>
                <img className="list__item" src={css3} alt="css_logo"/>
                <img className="list__item" src={nodedotjs} alt="node_logo"/>
                <img className="list__item" src={express} alt="express_logo"/>
                <img className="list__item" src={flask} alt="flask_logo"/>
                <img className="list__item" src={mysql} alt="mysql_logo"/>
                <img className="list__item" src={postgresql} alt="postgresql_logo"/>
                <img className="list__item" src={mssql} alt="mssql_logo"/>
                <img className="list__item" src={docker} alt="docker_logo"/>
                <img className="list__item" src={git} alt="git_logo"/>
                <img className="list__item" src={github} alt="github_logo"/>
            </div>
        </div>
    )
}